import './AsistantComponentsView.scss';

import { UiButton, UiIcon } from "libs/raas-ui-react-components/src/components"
import { useState } from 'react';

export default function Asistente(props?: any) {
    const [open, setOpen] = useState(true);

    function closeModal() {
        setOpen(false);
    }
    function openModal() {
        setOpen(true);
    }

    function emit({detail}: any){
        console.clear();
        props?.emiterButton(detail);
    }
    return (
        <nav className='test-navigator'>
            {open &&
                <>
                    <div className="header-content">
                        <h5>Asistente vistas</h5>
                        <div className="icon-content">
                            <UiIcon onIconClick={closeModal} icon={"close"} alt={"cerrar"}></UiIcon>
                        </div>
                    </div>
                    <div className="btn-wrapper">
                        {/* <UiButton className="" size='w100' type={"text"} idButton={"asientos"} onHandleClickButton={emit}> {'Mostrar asientos'}</UiButton>
                        <UiButton className="" size='w100' type={"text"} idButton={"botones"} onHandleClickButton={emit}> {'Mostrar botones'}</UiButton>
                        <UiButton className="" size='w100' type={"text"} idButton={"plani"} onHandleClickButton={emit}> {'Mostrar planificador'}</UiButton>
                        <UiButton className="" size='w100' type={"text"} idButton={"formulario"} onHandleClickButton={emit}> {'Mostrar formulario'}</UiButton> */}
                        <UiButton className="" size='w100' type={"text"} idButton={"home"} onHandleClickButton={emit}> {'Mostrar Home'}</UiButton>
                        <UiButton className="" size='w100' type={"text"} idButton={"login"} onHandleClickButton={emit}> {'Mostrar Login'}</UiButton>
                    </div>
                </>

            }
            {!open &&
                <>
                    <div className="header-content">
                        <div className="icon-content">
                            <UiIcon onIconClick={openModal} icon={"back"} alt={"oppen"}></UiIcon>
                        </div>
                    </div>
                </>
            }
        </nav>
    )
}